import { render, staticRenderFns } from "./HomeShortcut.vue?vue&type=template&id=903961b6&scoped=true"
import script from "./HomeShortcut.vue?vue&type=script&lang=js"
export * from "./HomeShortcut.vue?vue&type=script&lang=js"
import style0 from "./HomeShortcut.vue?vue&type=style&index=0&id=903961b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903961b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VChipGroup,VCol,VRow})
